import React from 'react';
import HeadCard from './headCard';

export default (props) => <HeadCard {...props} />;
